export default "__VITE_ASSET__4a8af958__"